<template>
  <L1>
    <template slot="slot_title">
      <RadioTop :options="pages" :defaultValue="page"
      @input="$router.replace({ name: $route.name, query: { page: $event } })"></RadioTop>
      <RadioTop :style="{marginLeft: 'auto'}" :options="['商品分類']" :defaultValue="page"
      @input="$router.replace({ name: $route.name, query: { page: $event } })"></RadioTop>
      </template>
      <SingleList v-if="page==='單品列表'" :types="typesp"/>
      <Single v-else-if="page==='單品管理'" :types="typesp"/>
      <Set v-else-if="page==='組合管理'" :types="types"/>
      <SetList v-else-if="page==='組合列表'" :types="types"/>
      <AddSet v-else-if="page==='新增組合'" :types="types"  :typesp="typesp"/>
      <EditSet v-else-if="page==='編輯組合'" :types="types"  :typesp="typesp"/>
      <GroupList v-else-if="page==='商品群組'" :types="types"  :typesp="typesp"/>
      <ProductGroup v-else-if="page==='新增群組'" :types="types"  :typesp="typesp"/>
      <EditGroup v-else-if="page==='編輯群組'" :types="types"  :typesp="typesp"/>
      <SpGroupList v-else-if="page==='特製群組'" :types="types"  :typesp="typesp"/>
      <SpProductGroup v-else-if="page==='新增特製群組'" :types="types"  :typesp="typesp"/>
      <SpEditGroup v-else-if="page==='編輯特製群組'" :types="types"  :typesp="typesp"/>

      <Options v-else-if="page==='選項設定'"/>
      <menucategory v-else-if="page==='商品分類'"></menucategory>
  </L1>
</template>

<script>
import Options from './setting/options.vue'
import Single from './setting/single.vue'
import Set from './setting/set.vue'
import EditSet from './setting/edit_set.vue'
import AddSet from './setting/add_set.vue'
import SingleList from './setting/single_list.vue'
import SingleListV2 from './setting/single_list_v2.vue'
import GroupList from './setting/groupList.vue'
import EditGroup from './setting/edit_product_group.vue'
import ProductGroup from './setting/product_group.vue'
import SpGroupList from './setting/groupListSp.vue'
import SpEditGroup from './setting/edit_product_group_sp.vue'
import SpProductGroup from './setting/product_group_sp.vue'
import Menucategory from './menucategory.vue'
import SetList from './setting/set_list.vue'
import SetListV2 from './setting/set_list_v2.vue'
import L1 from '../../components/layout/L1.vue'
import RadioTop from '../../components/radio/r1.vue'
import { getapi } from '../../store/fetch'
const VUE_APP_DELIVER_TEMPERATURE = JSON.parse(process.env.VUE_APP_DELIVER_TEMPERATURE)
export default {
  components: {
    L1,
    RadioTop,
    GroupList,
    SingleList: VUE_APP_DELIVER_TEMPERATURE ? SingleListV2 : SingleList,
    ProductGroup,
    EditGroup,
    SpGroupList,
    SpEditGroup,
    SpProductGroup,
    SetList: VUE_APP_DELIVER_TEMPERATURE ? SetListV2 : SetList,
    EditSet,
    AddSet,
    Single,
    Set,
    Options,
    Menucategory
  },
  data () {
    return {
      types: [],
      typesp: []
    }
  },
  async mounted () {
    const t = await getapi('selections/set-categories')
    this.types = t.map(e => e.name)
    const tp = await getapi('selections/prod-categories')
    this.typesp = tp.map(e => e.name)
  },
  computed: {
    pages () {
      if (!this.page) {
        return '單品列表_組合列表_單品管理_組合管理_商品群組_新增群組_特製群組_新增特製群組_選項設定'.split('_')
      } else if (this.page === '編輯組合') {
        return '單品列表_組合列表_單品管理_組合管理_編輯組合_商品群組_新增群組_特製群組_新增特製群組_選項設定'.split('_')
      } else if (this.page === '編輯特製群組') {
        return '單品列表_組合列表_單品管理_組合管理_商品群組_新增群組_特製群組_新增特製群組_編輯特製群組_選項設定'.split('_')
      } else if (this.page === '編輯群組') {
        return '單品列表_組合列表_單品管理_組合管理_商品群組_新增群組_編輯群組_特製群組_新增特製群組_選項設定'.split('_')
      } else {
        return '單品列表_組合列表_單品管理_組合管理_商品群組_新增群組_特製群組_新增特製群組_選項設定'.split('_')
      }
    },
    page () {
      return this.$route.query.page
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
